'use client'

import { motion } from 'framer-motion'
import { CheckCircle } from 'lucide-react'
import { SuccessConfetti } from '../Celebrations'
import { getPrimeiroNome, getWhatsAppUrl } from '../utilitarios'
import type { FormData } from '@/hooks/useAppStore'

interface StepSucessoProps {
  formData: FormData
}

export function StepSucesso({ formData }: StepSucessoProps) {
  const whatsappUrl = getWhatsAppUrl(formData)

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="w-full max-w-md mx-auto text-center">
      <SuccessConfetti />
      <motion.div initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }} className="mb-6">
        <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-green-500 to-green-600 flex items-center justify-center mx-auto mb-6 shadow-lg shadow-green-500/30">
          <CheckCircle size={40} strokeWidth={1.5} className="text-white" />
        </div>
        <h2 className="text-2xl sm:text-3xl font-semibold text-indigo-950 dark:text-white mb-3">Tudo certo, {getPrimeiroNome(formData.nome)}!</h2>
        <p className="text-indigo-950/60 dark:text-white/60 text-sm">Recebemos suas informacoes</p>
      </motion.div>

      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }} className="mb-6">
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-3 bg-green-500 hover:bg-green-600 active:bg-green-700 text-white font-medium px-8 py-4 rounded-full shadow-lg shadow-green-500/30 transition-all hover:scale-105 active:scale-95"
        >
          <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
          </svg>
          Falar no WhatsApp agora
        </a>
      </motion.div>

      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.4 }} className="space-y-3">
        <p className="text-indigo-950/50 dark:text-white/50 text-sm">Ou aguarde, entraremos em contato pelo</p>
        <p className="text-purple-400 font-medium">{formData.whatsapp}</p>
        <p className="text-indigo-950/40 dark:text-white/40 text-xs mt-4">Obrigado pela preferencia!</p>
      </motion.div>
    </motion.div>
  )
}
